module.exports = __webpack_public_path__ + "img/user.3d94ec7a.svg";